<template>
  <div id="app">
    <md-card>
      <md-card-header>
        <div class="md-title">Búsquedas en toponimia</div>
        <div class="md-subhead">Cartográfica de Canarias S.A.</div>
        <div class="md-subhead">{{ resultado }}</div>
      </md-card-header>

      <md-card-content>

        <md-input-container>
          <label>Introduzca un texto</label>
          <md-input v-model="txtSearch"></md-input>
        </md-input-container>

        <br />

        <md-list v-for="toponimo of toponimos" :key="toponimo.id">
            <toponimo :data="toponimo"></toponimo>
        </md-list>

      </md-card-content>
    </md-card>

  </div>
</template>

<script>
import axios from 'axios';
import lodash from 'lodash';
import Toponimo from './Toponimo.vue';

export default {
    name: 'app',
    data: function () {
      return {
        contacts: [],
        txtSearch: '',
        resultado: '',
        toponimos: []
      }
    },
    components: {
        'toponimo': Toponimo
    },
    watch: {
        txtSearch: function (newQuestion) {
            this.resultado = 'Esperando a que termine de escribir...'
            this.getToponimo()
        }
    },
    methods: {
      getToponimo: _.debounce(
        function () {
          this.resultado = 'Buscando ...'
          var vm = this
          axios.get('http://visor.grafcan.es/busquedas/toponimo/1/50/?', {
              params: {texto: this.txtSearch}
          })
          .then(function (response) {
              vm.toponimos = response.data.data;
              vm.resultado = _.capitalize(
                  'Nº resultados: ' + response.data.total + ' (' + response.data.time + ' ms)'
              );
          })
          .catch(function (error) {
              vm.resultado = 'Error! Could not reach the API. ' + error
            })
        },
        // This is the number of milliseconds we wait for the
        // user to stop typing.
        500
      )
    }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/App.vue